module.exports = __webpack_public_path__ + "static/media/michaelkazman_headshot.92c801ca.png";